import { AxiosError } from 'axios';

import apiClient from '../../../common/api/apiClient';
import { ApiError } from '../../../common/api/apiResponse';
import { ChangePasswordDto } from './changePassword.dtos';
import { showNotification } from '../../../common/actionCreators/dispatchNotification';


// endpoints
const changePasswordUrl = '/account/changePassword';

export const changePasswordApi = async (request: ChangePasswordDto) => {
  return await apiClient.post(changePasswordUrl, request)
    .then((res) => {
      showNotification('Your password has been updated.', 'success');
      return true;
    })
    .catch((err) => {
      if(err.response.data.PasswordMismatch)
        showNotification('Current password is incorrect.', 'error');
        else showNotification('An error occurred while changing password.', 'error');
    });
};
